import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as APLCategoryActions from './apl-category.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';


@Injectable({
  providedIn: 'root'
})
export class APLCategoryStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new APLCategoryActions.APLCategoryRefresh());
  }

  initListeners() {
    // APLCategory
    this.signalRService.hubConnection?.on(Channels.APLCATEGORY, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new APLCategoryActions.APLCategoryCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new APLCategoryActions.APLCategoryUpdate(data.id, data.obj));
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new APLCategoryActions.APLCategoryRefreshByID(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new APLCategoryActions.APLCategoryRefresh());
      }
    });

  }
}
